import { Link } from "react-router-dom";
import { ShieldCheck, Zap, Eye } from "lucide-react";
import { SEO } from "@/components/SEO";
import { UploadCard } from "@/features/upload/UploadCard";
import { useSettings } from "@/hooks/useSettings";
import { useAuth } from "@/context/AuthContext";

const ICONS = [Zap, ShieldCheck, Eye];

export default function Home() {
  const { settings } = useSettings();
  const { user } = useAuth();
  const jsonLd = { "@context": "https://schema.org", "@type": "WebApplication", name: settings.site_name, url: settings.site_url, description: settings.seo_description, applicationCategory: "UtilitiesApplication", offers: { "@type": "Offer", price: "0" } };
  return (
    <div className="container-x pb-20 pt-10 sm:pt-16" data-testid="home-page">
      <SEO jsonLd={jsonLd} />
      <section className="mx-auto max-w-2xl text-center">
        <h1 className="font-display text-4xl font-extrabold tracking-tight text-slate-900 sm:text-5xl lg:text-6xl" data-testid="hero-title">{settings.hero_title}</h1>
        <p className="mx-auto mt-4 max-w-lg text-base text-slate-600 md:text-lg" data-testid="hero-subtitle">{settings.hero_subtitle}</p>
      </section>
      <section className="mx-auto mt-10 max-w-2xl sm:mt-12">
        <UploadCard />
      </section>
      {settings.feature_sections?.length > 0 && (
        <section className="mx-auto mt-20 grid max-w-4xl gap-6 sm:grid-cols-3" data-testid="feature-sections">
          {settings.feature_sections.map((f, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div key={f.title} className="rounded-2xl border border-slate-200 bg-white p-6">
                <span className="grid h-9 w-9 place-items-center rounded-lg bg-indigo-50 text-indigo-600"><Icon className="h-4 w-4" /></span>
                <h3 className="mt-4 text-base font-semibold text-slate-900">{f.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-slate-500">{f.description}</p>
              </div>
            );
          })}
        </section>
      )}
      {!user && settings.registration_enabled && (
        <p className="mt-12 text-center text-sm text-slate-500">Want 50 GB and files that never expire? <Link to="/register" className="font-medium text-indigo-600 hover:underline" data-testid="home-register-link">Create a free account</Link>.</p>
      )}
    </div>
  );
}
